import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { FireblockService } from '../fireblockvault/fireblockvault.service';
@Component({
    selector: 'app-fireblocksync',
    templateUrl: './fireblocksync.component.html',
    styleUrls: ['./fireblocksync.component.css']
})
export class FireblockSyncComponent implements OnInit {
    displayedColumns = [
        'userid',
        'type',
        'currency',
        'assetid',
        'source_vault_id',
        'destination_vault_id',
        'amount',
        'networkFee',
        'feeCurrency',
        'txnid',
        'txHash',
        'note',
        'status',
        'is_processed',
        'is_gross',
        'fireblock_status',
        'fireblock_sub_status',
        'createdAt'
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<fireblockSyncData>;
    pageSize = 10;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private fireblock: FireblockService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.fireblock.getFireblockSyncRequest(this.filter).subscribe((success) => {
                let fireblockSyncRes = success.map(fireblockSync => {
                    fireblockSync.createdAt = moment(fireblockSync.createdAt).format('MM/DD/YY h:mm:ss A');
                    fireblockSync.lastUpdated = moment(fireblockSync.lastUpdated).format('MM/DD/YY h:mm:ss A');
                    return fireblockSync;
                })
                this.dataSource = new MatTableDataSource(fireblockSyncRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const fireblockSync = await this.dataSource.filteredData.map(x => ({
                userid: x.userid,
                type: x.type,
                currency: x.currency,
                assetid: x.assetid,
                source_vault_id: x.source_vault_id,
                destination_vault_id: x.destination_vault_id,
                amount: x.amount,
                feeCurrency: x.feeCurrency,
                networkFee: x.networkFee,
                txnid: x.txnid,
                txHash: x.txHash,
                note: x.note,
                status: x.status,
                is_processed: x.is_processed,
                is_gross: x.is_gross,
                fireblock_status: x.fireblock_status,
                fireblock_sub_status: x.fireblock_sub_status,
                createdAt: x.createdAt,
            }));
            TableUtil.exportArrayToExcel(fireblockSync, "fireblock-sync");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
}
export interface fireblockSyncData {
    userid: string,
    type: string,
    currency: number,
    assetid: number,
    source_vault_id: number,
    destination_vault_id: number,
    amount: number,
    feeCurrency: number,
    networkFee: string,
    txnid: string,
    txHash: string,
    note: string,
    status: string,
    is_processed: string,
    is_gross: string,
    fireblock_status: string,
    fireblock_sub_status: string,
    createdAt: string,
} 


// WEBPACK FOOTER //
// ./src/app/fireblocksync/fireblocksync.component.ts